<template>
  <div>
    <div class="clear"></div>
    <!-- Content
    =============================================-->
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <!-- Page Title
          =============================================-->
          <!-- <section id="page-title">
            <div class="container clearfix">
              <h1>วิธีเช่าชุด</h1>
            </div>
          </section>-->
          <h1
            style="font-size: 48px ; font-weight: 500;padding-left:120px; text-align:left; padding-bottom 60px; padding-top: 50px; "
          >คำถามที่พบบ่อย</h1>
          <!-- #page-title end -->

          <!-- Post Content
          =============================================-->
          <div class="row">
            <div
              class="postcontent nobottommargin clearfix"
              style="max-width:1150px; !important; margin-left: auto; margin-right: auto;"
            >
              <div id="faqs" class="faqs">
                <div class="toggle faq faq-marketplace faq-authors">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-question-alt"></i>1. ร้านเช่าชุดอยู่ที่ไหนคะ? 
                  </div>
                  <div
                    class="togglec"
                  >สาขาใหญ่อยู่ที่ จ.ลำปาง แต่โดยส่วนใหญ่เราเน้นส่งออนไลน์ ส่งชุดด่วนให้ลูกค้าภายใน 1-3 วัน ลูกค้าได้รับของรวดเร็วแน่นอนค่ะ และส่งฟรีทั่วไทย (ทางร้านใช้ขนส่ง Kerry และไปรษณีย์สาขาใหญ่ ลูกค้าที่อยู่ กทม. รับของภายใน 1 วัน)</div>
                </div>

                <div class="toggle faq faq-authors faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>2. ขั้นตอนในการจองผ่านเว็บไซด์ วางแผนการรับชุดอย่างไร?
                  </div>
                  <div
                    class="togglec"
                  >ทางร้านกำหนดให้ระยะเวลา 7 วัน ต่อการเช่า1ครั้ง ให้ลูกค้าวางแผนการรับและการส่งคืนได้ด้วยตัวเอง
เช่น ลูกค้าใช้งานวันที่ 5 เมษายน ให้กดวันรับชุดเป็น1เมษายน วันส่งคืน 7 เมษายน รวมทั้งสิ้น 7 วัน
ดังนั้น ร้านจะมีการส่งชุดให้ลูกค้าวันที่ 1 เมษายน ลูกค้ารอรับชุด 1-2 วัน และเมื่อใช้งานเสร็จส่งคืนได้เลยค่ะ</div>
                </div>

                <div class="toggle faq faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>3. หากส่งคืนล่าช้ากว่ากำหนด ทางร้านมีค่าใช้จ่ายเพิ่มมั้ย?
                  </div>
                  <div
                    class="togglec"
                  >ส่งคืนล่าช้าโดยที่ไม่มีการแจ้งล่วงหน้า ทางร้านคิดค่าปรับหลัง 7 วัน วันละ 100 บาทค่ะ</div>
                </div>

                <div class="toggle faq faq-authors faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>4. ค่ามัดจำชุดคิดอย่างไร?
                  </div>
                  <div
                    class="togglec"
                  >ค่ามัดจำชุด จะชำระเท่ากับราคาเช่าค่ะ เช่น ราคาเช่า 1,200 บาท / มัดจำ 1,200 บาท ค่ะ
( เงินมัดจำลูกค้าได้จะคืนเต็มจำนวนในกรณีทางร้านได้รับชุดส่งคืนแล้วเรียบร้อย)</div>
                </div>

                <div class="toggle faq faq-marketplace faq-authors">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>5. เครื่องประดับมีค่าใช้จ่ายเพิ่มมั้ย? 
                  </div>
                  <div
                    class="togglec"
                  >ทางร้านมีให้ลูกค้าเลือก ต่างหู ที่คาดผม หมวก รองเท้าและกระเป๋า ลูกค้าสามารถเลือกได้ด้วยตัวเองผ่านหน้าเว็บไซต์ได้เลย
<br>จองครบ 600 บาทขึ้นไป รับเครื่องประดับ 1 ชิ้น
<br>จองครบ 1,500 บาทขึ้นไป รับเครื่องประดับ 2 ชิ้น
<br>จองครบ 3,500 บาทขึ้นไป รับเครื่องประดับ 3 ชิ้น</div>
                </div>

                <div class="toggle faq faq-affiliates faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>6. ลูกค้าต้องทำความสะอาดชุดก่อนส่งคืนมั้ยคะ?
                  </div>
                  <div
                    class="togglec"
                  >เมื่อใช้เสร็จแล้วสามารถนำมาคืนได้เลยค่ะ ไม่ต้องซักทำความสะอาด ทางร้านบริการซักทำความสะอาดให้ทั้งก่อนรับไปและส่งคืนค่ะ (ไม่มีค่าใช้จ่ายเพิ่มเติมในส่วนนี้ค่ะ)
</div>
                </div>

                <div class="toggle faq faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>7. หากชุดเสียหาย ปรับอย่างไรค่ะ?
                  </div>
                  <div
                    class="togglec"
                  >หากมีรอยเลอะที่สามารถซักออกได้ หรือชุดเกิดการชำรุดเพียงเล็กน้อยและซ่อมแซมได้ ทางร้านไม่หักค่าประกันชุดค่ะ แต่หากชุดเลอะเยอะมากเป็นรอยหนักหรือไม่สามารถซักออกได้ รวมถึงชุดได้รับความเสียหายมาก ทางร้านจะหักค่าประกันชุดตามราคาที่เหมาะสมค่ะ</div>
                </div>
                <div class="toggle faq faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>8. ลูกค้าสามารถจองชุดล่วงหน้าได้นานแค่ไหน? 
                  </div>
                  <div
                    class="togglec"
                  >ทางร้านล็อคคิวชุดให้ ในกรณีชำระยอดเงินเข้ามาแล้วเท่านั้น แนะนำให้จองชุดล่วงหน้าได้ไวเท่าไหร่ยิ่งดีค่ะ หรือ 1-2 เดือนก่อนวันงาน หากใกล้วันเดินทางเกินไป ชุดที่เล็งไว้อาจจะโดนลูกค้าท่านอื่นจองไปก่อนได้นะคะ</div>
                </div>

              
              </div>
            </div>
          </div>
          <!-- ROW -->
          <!-- .postcontent end -->
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {
      welcome: "This is your profile"
    };
  },
  methods: {
    welcomeMessage() {}
  },
  components: {}
};
</script>
 
<style >
.toggle {
  text-align: left;
}
.togglec {
  text-align: left;
}
</style>